const getFormUrlEncodedData = (data: object): string => {
  const urlParams = new URLSearchParams();

  for (const key in data) {
    urlParams.append(key, data[key]);
  }

  return urlParams.toString();
};

export default getFormUrlEncodedData;
